import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SvgIconComponent } from "@shared/components/svg-icons/svg-icons.component";

@Component({
  selector: "app-title-sa",
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent],
  templateUrl: "./title-sa.component.html",
})
export class TitleSaComponent {
  @Input() colorLogo!: string;
  @Input() bgLogo!: string;
  @Input() animalName!: string; // Added to display the animal name in the title
}
